module.exports = __webpack_public_path__ + "img/zinc_gallery_1.ec024d6a.jpg";